function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaunchnavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "393px",
    height: "280px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8d6f9e",
    d: "M 228.5,51.5 C 225.093,53.0743 221.427,54.0743 217.5,54.5C 220.799,52.5165 224.466,51.5165 228.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9477a5",
    d: "M 206.5,58.5 C 206.027,59.9063 205.027,60.573 203.5,60.5C 203.973,59.0937 204.973,58.427 206.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9a80ac",
    d: "M 251.5,53.5 C 252.165,56.4815 252.498,59.6482 252.5,63C 252.656,68.0896 251.99,72.9229 250.5,77.5C 251.166,69.5173 251.499,61.5173 251.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9279a4",
    d: "M 160.5,89.5 C 159.07,90.5375 157.403,91.2041 155.5,91.5C 156.635,89.7868 158.302,89.1201 160.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8e6d9f",
    d: "M 147.5,94.5 C 147.027,95.9063 146.027,96.573 144.5,96.5C 144.973,95.0937 145.973,94.427 147.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#987ba8",
    d: "M 246.5,94.5 C 246.573,96.0269 245.906,97.0269 244.5,97.5C 244.427,95.9731 245.094,94.9731 246.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#755189",
    d: "M 135.5,103.5 C 132.5,107.167 129.167,110.5 125.5,113.5C 127.833,109.167 131.167,105.833 135.5,103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f6fa",
    d: "M 390.5,-0.5 C 391.167,-0.5 391.833,-0.5 392.5,-0.5C 392.5,92.8333 392.5,186.167 392.5,279.5C 392.167,279.5 391.833,279.5 391.5,279.5C 391.81,186.719 391.477,93.3853 390.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0d7e6",
    d: "M 242.5,104.5 C 242.69,108.79 241.69,112.79 239.5,116.5C 240.629,118.529 240.129,118.863 238,117.5C 237.147,119.125 236.147,119.458 235,118.5C 232.91,121.428 230.41,123.761 227.5,125.5C 232.92,118.755 237.92,111.755 242.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9076a1",
    d: "M 147.5,135.5 C 146.527,133.052 146.194,130.385 146.5,127.5C 137.312,127.801 128.312,127.801 119.5,127.5C 128.801,126.613 138.134,126.279 147.5,126.5C 147.5,129.5 147.5,132.5 147.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b9a6c3",
    d: "M 221.5,131.5 C 220.201,133.412 219.201,135.412 218.5,137.5C 218.34,135.801 218.506,134.134 219,132.5C 219.671,131.748 220.504,131.414 221.5,131.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#582671",
    d: "M 251.5,53.5 C 251.499,61.5173 251.166,69.5173 250.5,77.5C 249.646,83.2528 248.312,88.9195 246.5,94.5C 245.094,94.9731 244.427,95.9731 244.5,97.5C 243.434,99.7014 242.767,102.035 242.5,104.5C 237.92,111.755 232.92,118.755 227.5,125.5C 225.167,127.167 223.167,129.167 221.5,131.5C 220.504,131.414 219.671,131.748 219,132.5C 218.506,134.134 218.34,135.801 218.5,137.5C 217.628,143.151 216.295,148.818 214.5,154.5C 213.094,154.973 212.427,155.973 212.5,157.5C 206.568,169.273 198.235,179.107 187.5,187C 185.126,187.743 183.126,187.243 181.5,185.5C 181.5,176.833 181.5,168.167 181.5,159.5C 179.585,159.216 177.919,159.549 176.5,160.5C 174.565,161.709 172.565,161.542 170.5,160C 162.24,152.245 154.574,144.078 147.5,135.5C 147.5,132.5 147.5,129.5 147.5,126.5C 138.134,126.279 128.801,126.613 119.5,127.5C 118.104,121.602 120.104,116.936 125.5,113.5C 129.167,110.5 132.5,107.167 135.5,103.5C 137.637,100.027 140.637,97.6936 144.5,96.5C 146.027,96.573 147.027,95.9063 147.5,94.5C 150.007,93.1084 152.673,92.1084 155.5,91.5C 157.403,91.2041 159.07,90.5375 160.5,89.5C 163.903,88.0749 167.57,87.2415 171.5,87C 180.527,76.135 191.194,67.3016 203.5,60.5C 205.027,60.573 206.027,59.9063 206.5,58.5C 209.955,56.7909 213.621,55.4576 217.5,54.5C 221.427,54.0743 225.093,53.0743 228.5,51.5C 235.321,50.3454 242.321,50.1787 249.5,51C 250.381,51.7083 251.047,52.5416 251.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ad95b9",
    d: "M 156.5,123.5 C 156.127,126.574 155.461,129.574 154.5,132.5C 153.459,129.252 154.126,126.252 156.5,123.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#704d88",
    d: "M 221.5,121.5 C 220.089,123.914 218.089,125.581 215.5,126.5C 216.911,124.086 218.911,122.419 221.5,121.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9b7fac",
    d: "M 133.5,114.5 C 133.141,116.371 132.141,117.871 130.5,119C 136.825,119.5 143.158,119.666 149.5,119.5C 143.021,120.491 136.354,120.824 129.5,120.5C 129.622,117.708 130.956,115.708 133.5,114.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7a5b8d",
    d: "M 230.5,110.5 C 230.573,112.027 229.906,113.027 228.5,113.5C 228.427,111.973 229.094,110.973 230.5,110.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ede7f1",
    d: "M 156.5,98.5 C 158.099,98.2322 159.432,98.5655 160.5,99.5C 156.276,105.955 152.61,112.621 149.5,119.5C 143.158,119.666 136.825,119.5 130.5,119C 132.141,117.871 133.141,116.371 133.5,114.5C 139.971,107.433 147.637,102.099 156.5,98.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c4b3cd",
    d: "M 160.5,99.5 C 159.432,98.5655 158.099,98.2322 156.5,98.5C 157.997,97.6942 159.664,97.0276 161.5,96.5C 162.665,97.8595 162.332,98.8595 160.5,99.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bba9c6",
    d: "M 175.5,93.5 C 174.92,95.7488 173.587,97.4154 171.5,98.5C 172.08,96.2512 173.413,94.5846 175.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebf4",
    d: "M 244.5,57.5 C 244.664,64.2022 244.331,70.8689 243.5,77.5C 240.931,89.2079 236.598,100.208 230.5,110.5C 229.094,110.973 228.427,111.973 228.5,113.5C 225.705,115.751 223.372,118.418 221.5,121.5C 218.911,122.419 216.911,124.086 215.5,126.5C 203.426,136.071 190.926,145.071 178,153.5C 176.775,153.138 175.609,152.638 174.5,152C 167.965,145.297 161.298,138.797 154.5,132.5C 155.461,129.574 156.127,126.574 156.5,123.5C 160.215,114.406 165.215,106.072 171.5,98.5C 173.587,97.4154 174.92,95.7488 175.5,93.5C 182.685,83.4156 191.685,75.4156 202.5,69.5C 204.027,69.573 205.027,68.9063 205.5,67.5C 205.842,66.6618 206.508,66.3284 207.5,66.5C 213.094,65.0298 218.427,63.0298 223.5,60.5C 225.167,59.8333 226.833,59.1667 228.5,58.5C 233.833,58.1667 239.167,57.8333 244.5,57.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7a528d",
    d: "M 221.5,87.5 C 223.074,89.1016 223.741,91.1016 223.5,93.5C 221.926,91.8984 221.259,89.8984 221.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a2873",
    d: "M 218.5,84.5 C 219.167,85.8333 220.167,86.8333 221.5,87.5C 221.259,89.8984 221.926,91.8984 223.5,93.5C 222.862,106.308 216.195,112.142 203.5,111C 195.61,106.084 193.443,99.2506 197,90.5C 202.539,82.3727 209.706,80.3727 218.5,84.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#835d96",
    d: "M 203.5,94.5 C 203.065,97.8375 203.732,100.838 205.5,103.5C 204.504,103.586 203.671,103.252 203,102.5C 202.199,99.633 202.366,96.9664 203.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ede6f0",
    d: "M 205.5,103.5 C 203.732,100.838 203.065,97.8375 203.5,94.5C 206.913,88.792 211.08,88.1253 216,92.5C 217.105,100.562 213.605,104.228 205.5,103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b19dbe",
    d: "M 218.5,84.5 C 220.5,84.5 221.5,85.5 221.5,87.5C 220.167,86.8333 219.167,85.8333 218.5,84.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#896e9a",
    d: "M 244.5,57.5 C 245.164,60.1459 245.498,62.9792 245.5,66C 245.714,70.1327 245.048,73.966 243.5,77.5C 244.331,70.8689 244.664,64.2022 244.5,57.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b09bbb",
    d: "M 205.5,67.5 C 205.027,68.9063 204.027,69.573 202.5,69.5C 202.973,68.0937 203.973,67.427 205.5,67.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6b6ce",
    d: "M 223.5,60.5 C 218.427,63.0298 213.094,65.0298 207.5,66.5C 212.244,63.1382 217.577,61.1382 223.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#997ea8",
    d: "M 244.5,57.5 C 239.167,57.8333 233.833,58.1667 228.5,58.5C 233.767,56.5721 239.1,56.2388 244.5,57.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8c719e",
    d: "M 126.5,152.5 C 126.262,154.404 125.262,155.738 123.5,156.5C 123.738,154.596 124.738,153.262 126.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ede7f0",
    d: "M 204.5,158.5 C 203.094,158.973 202.427,159.973 202.5,161.5C 201.094,161.973 200.427,162.973 200.5,164.5C 197.215,168.452 193.548,172.119 189.5,175.5C 187.966,172.039 187.299,168.373 187.5,164.5C 187.833,161.833 188.167,159.167 188.5,156.5C 195.5,151.167 202.5,145.833 209.5,140.5C 209.833,141 210.167,141.5 210.5,142C 209.755,144.478 209.089,146.978 208.5,149.5C 206.342,152.148 205.008,155.148 204.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a995b8",
    d: "M 214.5,154.5 C 214.573,156.027 213.906,157.027 212.5,157.5C 212.427,155.973 213.094,154.973 214.5,154.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#856498",
    d: "M 204.5,158.5 C 204.573,160.027 203.906,161.027 202.5,161.5C 202.427,159.973 203.094,158.973 204.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f5e91",
    d: "M 122.5,159.5 C 122.277,163.162 121.277,166.495 119.5,169.5C 119.723,165.838 120.723,162.505 122.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#856397",
    d: "M 202.5,161.5 C 202.573,163.027 201.906,164.027 200.5,164.5C 200.427,162.973 201.094,161.973 202.5,161.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bfacc7",
    d: "M 129.5,161.5 C 128.744,165.767 127.411,169.767 125.5,173.5C 125.861,169.085 127.194,165.085 129.5,161.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f6393",
    d: "M 176.5,160.5 C 177.919,159.549 179.585,159.216 181.5,159.5C 181.5,168.167 181.5,176.833 181.5,185.5C 180.507,177.35 180.174,169.017 180.5,160.5C 179.167,160.5 177.833,160.5 176.5,160.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#562670",
    d: "M 139.5,171.5 C 138.5,171.5 137.5,171.5 136.5,171.5C 136.5,170.5 136.5,169.5 136.5,168.5C 137.854,164.968 139.854,161.802 142.5,159C 147.908,156.733 150.075,158.567 149,164.5C 146.248,167.453 143.082,169.786 139.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c5c91",
    d: "M 136.5,168.5 C 136.5,169.5 136.5,170.5 136.5,171.5C 137.5,171.5 138.5,171.5 139.5,171.5C 138.739,172.391 137.739,173.058 136.5,173.5C 135.212,171.701 135.212,170.035 136.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#582771",
    d: "M 129.5,161.5 C 127.194,165.085 125.861,169.085 125.5,173.5C 124.518,176.962 124.185,180.629 124.5,184.5C 126.099,184.768 127.432,184.434 128.5,183.5C 139.418,182.139 149.251,178.139 158,171.5C 158.772,171.645 159.439,171.978 160,172.5C 160.667,174.167 160.667,175.833 160,177.5C 156.574,180.793 152.741,183.459 148.5,185.5C 146.033,185.755 144.033,186.755 142.5,188.5C 139.012,188.705 135.679,189.539 132.5,191C 128.167,191.667 123.833,191.667 119.5,191C 117.972,189.352 117.305,187.352 117.5,185C 117.986,179.786 118.653,174.62 119.5,169.5C 121.277,166.495 122.277,163.162 122.5,159.5C 123.11,158.609 123.443,157.609 123.5,156.5C 125.262,155.738 126.262,154.404 126.5,152.5C 128.011,147.46 131.178,145.793 136,147.5C 136.167,148.167 136.333,148.833 136.5,149.5C 133.314,153.016 130.98,157.016 129.5,161.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#baa2c3",
    d: "M 125.5,173.5 C 125.5,176.833 125.5,180.167 125.5,183.5C 126.5,183.5 127.5,183.5 128.5,183.5C 127.432,184.434 126.099,184.768 124.5,184.5C 124.185,180.629 124.518,176.962 125.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a288b1",
    d: "M 148.5,185.5 C 146.967,187.245 144.967,188.245 142.5,188.5C 144.033,186.755 146.033,185.755 148.5,185.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchnavicon);
export default __webpack_public_path__ + "static/media/launchnavicon.71375ad27f8d32cc24fd06633ecda503.svg";
export { ForwardRef as ReactComponent };